const Bimo = "/static/img/examples/bimo.jpg";
const BimoCrop = "/static/img/examples/bimo-crop.jpg";
const BNHA = "/static/img/examples/bnha.png";
const GGO = "/static/img/examples/ggo.png";
const NGNL = "/static/img/examples/ngnl.png";
const Store = "/static/img/examples/store.jpg";
const MesseGif = "/static/img/examples/messe-gif.gif";
const Bag = "/static/img/examples/bag.jpg";

const Image600 = "/static/img/examples/image-res/800x600.jpg";
const Image720 = "/static/img/examples/image-res/1280x720.jpg";

const Gmaps = "/static/img/icon/gmaps.png";
const Loading = "/static/img/icon/loading.webp";
const Search = "/static/img/icon/search.svg";
const ArrowLeft = "/static/img/icon/arrow-left.png";
const ArrowRight = "/static/img/icon/arrow-right.png";
const Line = "/static/img/icon/line.svg";
const Facebook = "/static/img/icon/facebook.svg";
const FacebookGlyph = "/static/img/icon/Facebook_glyph.svg";
const TwitterGlyph = "/static/img/icon/Twitter_glyph.svg";
const LineGlyph = "/static/img/icon/Line_glyph.svg";
const Instagram = "/static/img/icon/instagram.svg";
const WhatsApp = "/static/img/icon/whatsapp.svg";
/* Lencana 360, disalin dari hanamaru supaya kartu toko di footer sama. */
const Tour360 = "/static/img/store/360.png.webp";
const MessengerSquare = "/static/img/icon/messenger_square.svg";
const TriangleLeft = "/static/img/icon/triangle-left.png";
const TriangleRight = "/static/img/icon/triangle-right.png";
const Cart = "/static/img/icon/cart.svg";
const TriangleDown = "/static/img/icon/triangle-down.png";
const Phone = "/static/img/icon/phone.png.webp";
/* `mail.png.webp` tidak pernah ada di repo ini, cuma `mail.png` -- ikonnya
   selama ini 404. Ketahuan waktu ia dipakai di tombol e-mail yang baru. */
const Mail = "/static/img/icon/mail.png";
const Face = "/static/img/icon/face.png";
const Cross = "/static/img/icon/cross.png";
const Trash = "/static/img/icon/trash.png";
const BCA = "https://kyoucdn.id/static/img/payment-methods/bca.png";
const BNI = "https://kyoucdn.id/static/img/payment-methods/bni.png";
const BRI = "https://kyoucdn.id/static/img/payment-methods/bri.jpg";
const Mandiri = "https://kyoucdn.id/static/img/payment-methods/mandiri.jpg";
const Messe = "/static/img/icon/messe.png";
const Messenger = "/static/img/icon/messenger.svg";
const Wishlist = "/static/img/icon/wishlist.svg";
const WishlistActive = "/static/img/icon/wishlist_active.svg";
const StoreIcon = "/static/img/icon/store.svg";
const FigureRescue = "/static/img/icon/figRescue.svg";
const URPlaceholder = "/static/img/icon/urPlaceholder.png";
const Notice18 = "/static/img/icon/notice_18.svg";
const NoAccess18 = "/static/img/icon/no_18_access.svg";
const R18Thumbnail = "/static/img/icon/r18_thumbnail.webp";
const Share = "/static/img/icon/share.svg";
const Edit = "/static/img/icon/edit.svg";
const RightArrow = "/static/img/icon/right-arrow.svg";
const Jenius = "https://kyoucdn.id/static/img/payment-methods/jenius.svg";
const GoPay = "/static/img/icon/gopay.svg";
const GoPayQR = "/static/img/icon/gopay_qr.svg";
const BankTransfer = "/static/img/icon/bank-transfer.png";
const Tokopedia = "/static/img/icon/todokete.svg";
const Dana = "/static/img/icon/dana.png.webp";
const DanaQR = "/static/img/icon/dana_qr.png";
const QRkuBCA = "/static/img/icon/qrkubca.png";
const QRkuBCAQR = "/static/img/icon/qrkubca_qr.jpg";
const OVO = "/static/img/icon/ovo.png";
const QRIS = "https://kyoucdn.id/static/img/payment-methods/qris.svg";
const ShopeePay = "/static/img/payment_logo/logo_shopeepay.png";
const Permata = "/static/img/payment_logo/logo_permatabank.png";
const CIMB = "/static/img/payment_logo/logo_CIMBNiaga.png";
const Paypal = "https://kyoucdn.id/static/img/payment-methods/paypal.png"; 
const Check = "/static/img/icon/check.svg";
const OrangeCheck = "/static/img/icon/check_orange.svg";
const GreenCheck = "/static/img/icon/check_green.svg";
const OrangeCross = "/static/img/icon/cross_orange.svg";
const Transactions = "/static/img/icon/transactions.svg";
const Filter = "/static/img/icon/filter.svg";
const Sort = "/static/img/icon/sort.svg";
const WishlistNavbar = "/static/img/icon/wishlist_navbar.svg";
const MyAccount = "/static/img/icon/my_account.svg";
const Address = "/static/img/icon/address.svg";
const History = "/static/img/icon/history.svg";
const HistoryOrange = "/static/img/icon/history-orange.svg";
const Danger = "/static/img/icon/danger.svg";
const DangerFilled = "/static/img/icon/danger_filled.svg";
const Logout = "/static/img/icon/logout.svg";
const Menu = "/static/img/icon/menu.svg";
const SearchOrange = "/static/img/icon/search_orange.svg";
const Login = "/static/img/icon/login.svg";
const UR = "/static/img/icon/ur.svg";
const WishlistNavbarGray = "/static/img/icon/wishlist_navbar_gray.svg";
const Spinner = "/static/img/icon/spinner.svg";
const URTick = "/static/img/icon/urtick.svg";
const Home = "/static/img/icon/home.svg";
const QRISIcon = "/static/img/icon/ewallet.png";
const QRISIconSmall = "/static/img/icon/ewallet_small.png";
const BliBli = "/static/img/icon/blibli.svg";

const KyouLogo = "/static/img/logo/kyou.png";
const KyouMascot = "https://kyoucdn.id/mascot/Mascot.svg";
const KyouMascotBg = "/static/img/logo/kyou-mascots-bg.png";
const KyouMascotBg2 = "/static/img/logo/kyou-mascots-bg2.png";

const AmiAmi = "/static/img/logo/amiami.png";
const Mandrake = "/static/img/logo/mandrake.png";
const CdJapan = "/static/img/logo/cdjapan.png";
const Amazon = "/static/img/logo/amazon.png";
const Surugaya = "/static/img/logo/surugaya.png";
const Animate = "/static/img/logo/animate.png";
const Melonbooks = "/static/img/logo/melonbooks.png";
const HLJ = "/static/img/logo/hlj.png";
const Toranoana = "/static/img/logo/toranoana.png";
const HobbySearch = "/static/img/logo/hobby-search.png";
const Rakuten = "/static/img/logo/rakuten.png";
const Gamers = "/static/img/logo/gamers.png";
const TowerRecords = "/static/img/logo/tower-records.png";
const Aniplex = "/static/img/logo/aniplex.png";
const Mercari = "/static/img/logo/mercari.png";

const PVC = "/static/img/sidebar/pvc.png";
const Figma = "/static/img/sidebar/figma.png";
const Nendo = "/static/img/sidebar/nendo.png";
const ModelKit = "/static/img/sidebar/model-kit.png";
const Plush = "/static/img/sidebar/plush.png";
const Merch = "/static/img/sidebar/merch.png";
const LnEn = "/static/img/sidebar/ln-en.png";
const MangaEn = "/static/img/sidebar/manga-en.png";
const LnJp = "/static/img/sidebar/ln-jp.png";
const MangaJp = "/static/img/sidebar/manga-jp.png";

const FPTrophyBronze = "/static/img/icon/Bronze.svg";
const FPTrophySilver = "/static/img/icon/Silver.svg";
const FPTrophyGold = "/static/img/icon/Gold.svg";

const SearchNotFound = "/static/img/icon/SearchNotFound.gif";

const AlphaStore = "/static/img/store/Alpha.png";
const Gath01 = "/static/img/store/Gath01.jpg";
const Gath02 = "/static/img/store/Gath02.jpg";
const Gath03 = "/static/img/store/Gath03.jpg";
const Gath04 = "/static/img/store/Gath04.jpg";
const Gath05 = "/static/img/store/Gath05.jpg";
const KyouTeam = "/static/img/store/kyou_team.jpg";

const Ranking0 = "/static/img/ranking/ranking0.png";
const Ranking1 = "/static/img/ranking/ranking1.png";
const Ranking2 = "/static/img/ranking/ranking2.png";
const Ranking3 = "/static/img/ranking/ranking3.png";
const Ranking4 = "/static/img/ranking/ranking4.png";

const DesktopSaleBanner = "/static/img/banner/desktop.png";
const MobileSaleBanner = "/static/img/banner/mobile.png";

export default {
  Bimo,
  BimoCrop,
  BNHA,
  GGO,
  NGNL,
  Store,
  MesseGif,
  Bag,

  Image600,
  Image720,

  Gmaps,
  Loading,
  Search,
  ArrowLeft,
  ArrowRight,
  Line,
  Facebook,
  FacebookGlyph,
  LineGlyph,
  TwitterGlyph,
  Instagram,
  WhatsApp,
  Tour360,
  MessengerSquare,
  TriangleLeft,
  TriangleRight,
  Cart,
  TriangleDown,
  Phone,
  Mail,
  Face,
  Cross,
  Trash,
  BCA,
  BNI,
  BRI,
  Mandiri,
  Messe,
  Messenger,
  Wishlist,
  WishlistActive,
  StoreIcon,
  FigureRescue,
  URPlaceholder,
  Notice18,
  NoAccess18,
  R18Thumbnail,
  Share,
  Edit,
  RightArrow,
  Jenius,
  GoPay,
  GoPayQR,
  BankTransfer,
  Tokopedia,
  Dana,
  DanaQR,
  QRkuBCA,
  QRkuBCAQR,
  OVO,
  QRIS,
  ShopeePay,
  Permata,
  CIMB,
  Paypal,
  Check,
  OrangeCheck,
  Transactions,
  Filter,
  Sort,
  WishlistNavbar,
  MyAccount,
  Address,
  History,
  HistoryOrange,
  Danger,
  DangerFilled,
  Logout,
  Menu,
  SearchOrange,
  Login,
  UR,
  WishlistNavbarGray,
  GreenCheck,
  Spinner,
  URTick,
  OrangeCross,
  Home,
  QRISIcon,
  QRISIconSmall,
  BliBli,

  KyouLogo,
  KyouMascot,
  KyouMascotBg,
  KyouMascotBg2,

  AmiAmi,
  Mandrake,
  CdJapan,
  Amazon,
  Surugaya,
  Animate,
  Melonbooks,
  HLJ,
  Toranoana,
  HobbySearch,
  Rakuten,
  Gamers,
  TowerRecords,
  Aniplex,
  Mercari,

  PVC,
  Figma,
  Nendo,
  ModelKit,
  Plush,
  Merch,
  LnEn,
  MangaEn,
  LnJp,
  MangaJp,

  FPTrophy: {
    Bronze: FPTrophyBronze,
    Silver: FPTrophySilver,
    Gold: FPTrophyGold
  },
  SearchNotFound,

  AlphaStore,
  Gath01,
  Gath02,
  Gath03,
  Gath04,
  Gath05,
  KyouTeam,

  Ranking: [Ranking0, Ranking1, Ranking2, Ranking3, Ranking4],
  MobileSaleBanner,
  DesktopSaleBanner
};
